module.exports = __webpack_public_path__ + "img/A1.c64dc6f8.svg";